// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header-font":"header-font","vertical-align":"vertical-align","header-text-margin":"header-text-margin","header-text-padding":"header-text-padding"};